// Announcements — the per-user login feed (published announcements). The admin authoring
// hooks (list-all / save / delete) live in features/admin.ts.

import { useQuery } from '@tanstack/react-query';
import type { Announcement } from '@technohull/shared';
import { api } from '../lib/api.js';

export function useAnnouncementsFeed() {
  return useQuery({
    queryKey: ['announcements', 'feed'],
    queryFn: () => api.get<{ announcements: Announcement[] }>('/api/announcements'),
    staleTime: 5 * 60_000,
  });
}
